/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SpaceFileTileMode {
	OnDemand = 0,
	PreGenerated = 1,
}
